import { fleetEnvironment } from '../fleet-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { PagedCollectionParams } from '../../../models/paged-collection-params';
import { globalVehicleSchema } from '../schemas/global-vehicle.schema';
import { createPagedCollectionSchema } from '../../../utils/create-paged-collection-schema';
import { fromFetch } from 'rxjs/fetch';

export function getVehiclesSearch(
  this: unknown,
  params: PagedCollectionParams,
  partnerId: string,
  deviceIdExpression: string
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${fleetEnvironment.resolve(this).vehiclesSearchUrl}?${
          params.urlParams
        }&partnerId=${encodeURIComponent(partnerId)}&deviceIdExpression=${encodeURIComponent(deviceIdExpression)}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(createPagedCollectionSchema(globalVehicleSchema)));
}
